﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customEventThemeColorInsert from './tpl/customEventThemeColorInsert.html';
import language from '../../../common/language';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import * as Entities_Memory from '../../entities/memory';
import * as Entities_Memory_PositionPageable from '../../entities/memoryPositionPageable';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import config from '../../../common/config';
import Help from '../../helper/help';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_customEventThemeColorInsert();
    },
    regions: {
    },
    onBeforeShow: function () {
    },
    initialize: function () {
        this.app = this.options.app;

        var userChannel = Backbone.Radio.channel('app');
        var self = this;
        //userChannel.on('customEventThemeColor:eventChanged', function() {
        //    self.selectEventChange();
        //});
        this.listenTo(userChannel, 'customEventThemeColor:eventChanged', function() {
            self.selectEventChange();
        });
    },
    ui: {
        'customEventThemeColorInsert_btnPushSubmit': '#customEventThemeColorInsert_btnPushSubmit',
        'customEventThemeColorInsert_inputPush': '#customEventThemeColorInsert_inputPush'
        
    },
    events: {
        'click @ui.customEventThemeColorInsert_btnPushSubmit': 'btnPushSubmit'
    },
    onRender: function () {
        //this.setupPushBtn(this.app.entities.models.configSubscription[0].attributes.EnablePush);

        return this;
    },
    selectEventChange : function () {
    },
    //setupPushBtn: function (enable) {
    //    if (this.collection.fullCollection.length <= 0) {
    //        enable = false;
    //    }

    //    if (enable) {
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.removeClass('btn-secondary');
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.addClass('btn-primary');
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.prop('disabled', false);
    //    } else {
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.removeClass('btn-primary');
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.addClass('btn-secondary');
    //        this.ui.customEventThemeColorInsert_btnPushSubmit.prop('disabled', true);
    //    }
    //},
    btnPushSubmit: function (event) {
        var self = this;
        var errors = [];

        //var message = this.ui.customEventThemeColorInsert_inputPush.val();

        //if (!message) {
        //    errors.push({ name: 'customEventThemeColorInsert_inputPush', message: resources.X100324 });
        //}

        if (errors.length > 0) {
            this.showErrors(errors);
        }
        else {
            //var copyModel = this.collection.where({ DefaultInsert: true })[0];
            var copyModel = this.options.defaultCollection.where({ Selected: 1 })[0];
            var tmpModel = new this.collection.model();
            tmpModel = copyModel.clone();

            tmpModel.attributes.id = -1;
            tmpModel.attributes.Name = self.ui.customEventThemeColorInsert_inputPush.val();
            var position = -1;
            this.collection.forEach(function (entry) {
                if (entry.attributes.Position >= position) {
                    position = entry.attributes.Position;
                }
            });

            position += 1;

            tmpModel.attributes.id = position;
            tmpModel.attributes.Position = position;
            tmpModel.attributes.Standard = 2;
            tmpModel.attributes.Default = false;

            this.collection.add(tmpModel);
            self.hideErrors();
            self.ui.customEventThemeColorInsert_inputPush.val("");

            var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.localSetting.attributes.EventId, ModuleType: 98 })[0];
            var data = JSON.parse(customModule.attributes.Data);
            var customModule_data = new Entities_Memory.Model(data[0].Data);
            var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

            customModule_data.attributes.ThemeCollection = this.collection.toJSON();
            var strJson = JSON.stringify(customModule_data.toJSON());
            customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

            customModule.save(customModule.attribute, {
                silent: false,
                wait: true,
                success: function () {
                }
            });


            /*this.collection.create(tmpModel, {
                silens :true,
                wait: true,
                success: function (response) {
                    self.hideErrors();
                    self.ui.customEventThemeColorInsert_inputPush.val("");
                    //var userChannel = Backbone.Radio.channel('app');
                    //userChannel.trigger('customEventThemeColor:pushMessage');
                }
            });*/
        }
    }
}, Backbone.Radio.Requests);
